module.exports = __webpack_public_path__ + "img/step05_c_stand_power_right_screws.2b516c93.png";